import React, { createContext, useState } from 'react';

interface ContextInterface {
	sectionId: string | null;
	setSectionId: (id: string | null) => void;
}

const INITIAL_STATE: ContextInterface = {
	sectionId: null,
	setSectionId: () => {},
};

export const CustomizerContext = createContext<ContextInterface>(INITIAL_STATE);

export const CustomizerContextProvider = (props: any) => {
	const { children }: { children: any } = props;

	const [sectionId, setSectionId] = useState<string | null>(INITIAL_STATE.sectionId);

	return (
		<CustomizerContext.Provider
			value={{
				sectionId,
				setSectionId,
			}}
		>
			{children}
		</CustomizerContext.Provider>
	);
};
